module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gEQCSAT5Mow9QAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAuklEQVRYw+2YPQ7CMAxGnwsLAzdoZpg5MDsszAzcCFVKLhAG0gURqSgFDPosZUgsOU/5nD8bdcsPfaPNJsXrcGYCmgq0BU5AKlrnSg60tFq8VObejI4ADDNM2NoGICyAPbBzoNYK6K0s2dpJCiWr6KtdJiABzWXLJ2P2YYYsyf4uh1596bX6JdlvA9kbfhc6hwQkIAEJSEAC8nbbeyo2xA64OFqgM9wrVx4KVlegH8kCcATiF0AicBhhbkDeildOyI2mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Datebox/calendar-range.png
// module id = 93
// module chunks = 0